import { render, staticRenderFns } from "./VipChargeItem.vue?vue&type=template&id=dd31eed4&scoped=true&"
import script from "./VipChargeItem.vue?vue&type=script&lang=js&"
export * from "./VipChargeItem.vue?vue&type=script&lang=js&"
import style0 from "./VipChargeItem.vue?vue&type=style&index=0&id=dd31eed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd31eed4",
  null
  
)

export default component.exports